export default "/images/image_6.jpg?72c6f736c46ff37d87aefcafd4e590d1";